import type {TimeRange} from 'bitmovin-player';
import {assign, createMachine} from 'xstate';

type Context = {
  hasPlayed: boolean;
  volume: number;
  timestamp: number;
  duration: number;
  isLive: boolean;
  buffered: TimeRange[];
};

const initalContext: Context = {
  hasPlayed: false,
  volume: 100,
  timestamp: 0,
  duration: 0,
  isLive: false,
  buffered: [],
};

export const uiMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QFcCWA6ANgewIYVQDsoBiWbZAJwGMwAZPCSAbQAYBdRUAB21lQAuqbIS4gAHogBMAVgDM6ACxyA7DNYA2RVNYBOFQA5FMgDQgAnog26Z6DQdkHdzgIyKXBjQF8vZtOnIqWgZ8SBJkQhx8AGUKGjA2TiQQXn4hETFJBFkFZTVNbT1DYzNLBC1bDykNFzldOQ05AxUfPwxA+JCmCBJqAAtcYjAANWxMZABbBI4xVMFhUWSs3Q0NdBVZTRknFTkZKQNS6RVFdCkXZ103KV1NaplWkH8O4MYw5G4IXAEwABEqb4LRKzPjzDJLRArBQGdSaQwnJoaI4IFwqFToZqsVg6VhGRSeby+J7tOKvUI9D5fH4AIWQADM6WBKCwZsk5ulFqBlo10DI1C5WG5WLtPMiDC5eTjWNsattZI9nqT6G8IOhuJhcOYAEa4agAawCAm+yFgao15iIpG4uBN0ySPFBHMykN26BcmykincF1xKmRApctgc2OlmlWKmcCpJQWV5LNmp1+sNxtN6s1lvCn2+YAAKqgprAjRNuMC2Y6Fs6UQLWOs5O6Gjo6nXTBZEAKZLYNCpBVDdMptlGAkqupB49rdQbCymxxnYGAwHrSw60hWISi5Ht0H3nA45DjPYp-YH0Xp5BdZGejIOXrHumPE5OjQITWqbXOemnzEuUuXwVyXQo7rqAeLg+s0-phuge7Yhowr7E4nrXsOKr3hOybPqmb5hHOC7fuyq7-uum7brou77l6YobG6xiyDUigbF6LREoqMYjqqn4PuhL42gI2CfmQRqUAIAAK5oPnhv6chIVgwlBQENAYcEFEezToMKrAKVIUgqKiuhSEhrEoRxaFThh6A8Xx5okIQ2CiQmE4SSuf7SeUsl1jk9hKVoEGBhiOgHIo1iGLBhJtEOhlxsZSY4XqGZ0kQqCwH0kDRPOsXEI5YJSVkii3G6QGyNpqi1CcyIbLY6nnKBaLbIGBmdChEzID80RPi+TU-BShAdXaIJOdlVisKcpE6DI9HNBoMgXP6+I1rscgadYWieC49VknePWtdOEQ9T0PWZU6a6wcNwZjfCk3Ta2KJnmcG56PcArzWtt6jnSyCYJgsDUMyYCEFtZkAO5EBA2AA2Ev0-JQABi72fd986EAdBEuXRSh1s4e61AKNTIvRujrNK7oioGgZaM9bHoG9H1fT9f1taaVNw7TJBgOIggw9T8O-UjzlZBoshbuKGP2BUKy4zcZyhjp1jyBpDzMdGDVxjaBDYDmlATrAJDMhM2AAG6QAAgsgqvqw5rLLllYhlETgEjd2Y0Cn2UhmFkqL0RigqejINSqON5MoSrwhm-qWv4N0xumxr+o8wNCCXLyWzlbcC2ev6Ip2OGPukbs8EB8rJvB9Hepa3OmBgNQnWR0X5v2j+-WVrUGlnDUfaKQY4pGH6V2otpvIqFoihDane76Qr4VK3eQdq8XmGEGAmAAPLcL9vQ4HO1e2YMC+x43goSmoNi6TC0pyIePc+1ImfqA4Jw2IKBj51Phcz5rr7z5gADC69hHxv2b8JbemBd5rjcB4OSdRdJt27HIf0jteQdwOMKdwWJQrEgnutUc08Q4l3MgDXA8xiAAKAd-PgYASDiFMmAcydJIYAApYQAEpwiK0waqbBs88EEKEEQl+gCP6kLnCAwioFwG5QMGfS44oxr+gaGsOsuJVBYlUBuMeYUbwU1gMgLUQgBDlxwWHCA3RojaN0fo4uwiXIAFo-YYjbnpIoGw6ywKuo0CUuJPQRhxHUQKT9RxaJ0YIcxmttZgF1gbCAJjAl6NzBYi29crZrlYMiVgfjVQBLMbEkJZcK6dSiZknBlisjJKuqk8eGiUIZKCVk0OJACCwFwFqcukTTHVMKfE-CvNEAlLKGU9RyE4xVJiQYgIrSYn8IXsvVe1Af75OqRM4BHTJKVisVpfG-ZAqeGcPzfEuMz4Eymr6Zw0oHBpNGdE4JodzmZIWYI3+K8-pjPLgsopiArGBVOKBJwfJJpXDPsiBa+NW7Hg7gtDSbgzlDMubg3A+DCFQDmeMkhP8KFUJofQphLCMEvXSU8mpMK4U8IRXi25P9XnlDWB8-EgVlF8gjAC6oaluy7HcOoQ+qIfBEhskweAyQ0B9USYRKxsEDD5W+QPGQfzz5lCsaiCqWJsSyDRHUbEihBxRAIMQAVh1CLaGRI0Wwkq9I+0UtUPYarykDO6Nq5GWQrE+xrF8mwEqpXIisapXKlxcR6SaDRM5UU9Q2q6QgZQnyCr7F2DpJo+rVD90VdiGEFwmL9IineANXFeWWx1S5fEV9QKFQjcVaNV09KiugjcPkkr5CGH9WJEy9MZxarLA3UBegayqHULNQMdQtJHj5Gpfy9ElGgXorW+y0UG3WltBAINccjCiuNYKOoHYTjeR7oKeR-lQyrHsGO8cE7pwWU-LOysPs1j5v2Aa2oXoXAqQlN2nSiDoIWpTZPUc6bTIvj6IlAQJ61yy3ygWoqUbDg93dI66tWgNiKQ3C+9BFTIp1uimlS0f6REblsDpR2WwxouLKF4uwFw6yTR0soK8lrU2jk2vTNDOa9zrGDF6DcbhvnSrbE2W6Nwuz8ymgcM51Hpy7Vo1kJxUE+QaQcLlLSDQZpODkloPcO77ANH481MA-0Xw7TUzO5tgqc2KQYzoJjdZ8Q2DYyifEaxxSNAjHyPSNxH4UbfaqRmNMEYaczQk7NOV6OGB0GZoCFwWxlDPgfUM7dsRXCcGc1zXM6bTiBoQEGYMdNZttYgWahnTzuFkEFvZtgDhGDcICrsWkYuwzc79DzlMKtxeE4gCMNZarODGhIsBt6rp5AY0YLsdQdKyF0Gcjhmt6vx3cOsMBEYGJ7EMP6bSorxTCm41oBVaj4NWqwS-EZ1oP5TKkp0uOoF9AYgjJ4G4uINIlB7vzK+9hbiRfbp6NBLFnPmS25wnbC87mpa8+llEXGJsmtuC4WCpFQM2y9AVmEuXNiBm0kN97b9YXcMtMQgRP9RukXxqR3S02+Tg7bDRNSvs6JuCHmiSFeKDGjfte6MVzrfnXrgfjNrah5t6QHvDpzbDrltM4VCsACy9s08Crdjw+h5BrJ2OZ7Q+NRr3T0CDoUz3WE4t58M-nJLkVkJ+wdlZIPseKX2PmqNk0CfZA9sxhE9gQewRrdztXAuRnI-hYi552u5w06vjYPSqwporHOMyvZpwHbui9B3CN9ROVeCAA */
  createMachine(
    {
      tsTypes: {} as import('./uiMachine.typegen').Typegen0,
      schema: {
        context: initalContext,
        events: {} as
          | {
              type: 'sourceLoaded';
              isLive: boolean;
              duration: number;
              buffered: TimeRange[];
            }
          | {
              type: 'pause';
            }
          | {
              type: 'play';
            }
          | {
              type: 'mute';
            }
          | {
              type: 'unmute';
            }
          | {
              type: 'startPlayback';
            }
          | {
              type: 'noPlayback';
            }
          | {
              type: 'unloadSource';
            }
          | {
              type: 'changeVolume';
              value: number;
            }
          | {
              type: 'updateTimestamp';
              value: number;
            }
          | {
              type: 'updateDuration';
              value: number;
            }
          | {
              type: 'enterFullscreen';
            }
          | {
              type: 'exitFullscreen';
            }
          | {
              type: 'updateBuffered';
              value: TimeRange[];
            }
          | {
              type: 'seek';
              value: number;
            }
          | {
              type: 'finishedSeeking';
            },
      },
      initial: 'loading',
      states: {
        loading: {
          entry: 'resetContext',
          on: {
            sourceLoaded: {
              target: 'sourceLoaded',
              actions: 'setSource',
            },
          },
        },

        sourceLoaded: {
          states: {
            playback: {
              initial: 'status',
              states: {
                status: {
                  initial: 'autoplay',
                  states: {
                    playing: {
                      entry: 'setHasPlayed',
                      on: {
                        pause: {
                          target: 'paused',
                        },

                        updateTimestamp: {
                          actions: 'setTimestamp',
                        },

                        seek: {
                          target: '#ui.sourceLoaded.playback.seeking',
                          actions: 'setSeekTarget',
                        },
                      },
                    },

                    paused: {
                      on: {
                        play: {
                          target: 'playing',
                        },

                        seek: {
                          target: '#ui.sourceLoaded.playback.seeking',
                          actions: 'setSeekTarget',
                        },
                      },
                    },

                    autoplay: {
                      on: {
                        startPlayback: {
                          target: 'playing',
                        },
                        noPlayback: {
                          target: 'paused',
                        },
                      },
                    },

                    hist: {
                      type: 'history',
                      history: 'shallow',
                    },
                  },
                },

                seeking: {
                  on: {
                    finishedSeeking: 'status.hist',
                  },
                },
              },
            },

            muteStatus: {
              initial: 'unmuted',
              states: {
                muted: {
                  on: {
                    unmute: {
                      target: 'unmuted',
                    },
                  },
                },
                unmuted: {
                  on: {
                    mute: {
                      target: 'muted',
                    },
                  },
                },
              },
            },

            fullscreenStatus: {
              states: {
                windowed: {
                  on: {
                    enterFullscreen: 'fullscreen',
                  },
                },
                fullscreen: {
                  on: {
                    exitFullscreen: 'windowed',
                  },
                },
              },

              initial: 'windowed',
            },
          },
          on: {
            unloadSource: {
              target: 'loading',
            },

            changeVolume: {
              actions: 'setVolume',
              internal: true,
            },

            updateDuration: {
              actions: 'setDuration',
              internal: true,
            },

            updateBuffered: {
              actions: 'setBuffered',
              internal: true,
            },
          },
          type: 'parallel',
        },
      },
      id: 'ui',
    },
    {
      actions: {
        setSource: assign((context, event) => ({
          ...context,
          duration: event.duration,
          isLive: event.isLive,
        })),
        setHasPlayed: assign((context) => ({
          ...context,
          hasPlayed: true,
        })),
        resetContext: assign(() => initalContext),
        setVolume: assign((context, event) => ({
          ...context,
          volume: event.value,
        })),
        setTimestamp: assign((context, event) => ({
          ...context,
          timestamp: event.value,
        })),
        setDuration: assign((context, event) => ({
          ...context,
          duration: event.value,
        })),
        setBuffered: assign((context, event) => ({
          ...context,
          buffered: event.value,
        })),
        setSeekTarget: assign((context, event) => ({
          ...context,
          buffered: [],
          timestamp: event.value,
        })),
      },
    }
  );
